import Vue from 'vue'
const permission={
    inserted(el, value, vnode) {
		let newarr=value.expression.split("")
		newarr.splice(0,1)
		newarr.pop()
		var code=newarr.join('')
       var permissions=localStorage.getItem('resources')
       if(permissions==null||permissions==""||permissions==undefined){
       	el.parentNode && el.parentNode.removeChild(el)
       }
		if(!(permissions.includes(code))){
			el.parentNode && el.parentNode.removeChild(el)
		}
    }
}
Vue.directive('permission', permission)